module.exports = __webpack_public_path__ + "static/img/APPStore.9ec8f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/softwares/APPStore.png
// module id = xXF0
// module chunks = 6